var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "period-summary" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "period-info" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "period-details" }, [
              _c("div", { staticClass: "period-header" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "period-content" }, [
                  _c("div", { staticClass: "period-title" }, [
                    _vm._v("Período Seleccionado"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-value" }, [
                    _vm._v(_vm._s(_vm.getPeriodLabel(_vm.periodo))),
                  ]),
                  _vm._v(" "),
                  _vm.fechaInicio && _vm.fechaFin
                    ? _c("div", { staticClass: "period-dates" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.formatDate(_vm.fechaInicio)) +
                            " - " +
                            _vm._s(_vm.formatDate(_vm.fechaFin)) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "period-stats" }, [
              _c("div", { staticClass: "stat-item" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.getPeriodDays())),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Días del Período"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-item" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.getPeriodHours())),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Horas del Período"),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(4),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-calendar-check text-primary" }),
      _vm._v(" Resumen del Período"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "period-icon" }, [
      _c("i", { staticClass: "fal fa-calendar-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-success" }, [
      _c("i", { staticClass: "fal fa-check-circle" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-info" }, [
      _c("i", { staticClass: "fal fa-clock" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "period-comparison" }, [
      _c("h6", [
        _c("i", { staticClass: "fal fa-chart-line text-warning" }),
        _vm._v(" Comparación con Períodos Anteriores"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comparison-grid" }, [
        _c("div", { staticClass: "comparison-item" }, [
          _c("div", { staticClass: "comparison-header" }, [
            _c("div", { staticClass: "comparison-icon text-success" }, [
              _c("i", { staticClass: "fal fa-arrow-up" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "comparison-content" }, [
              _c("div", { staticClass: "comparison-label" }, [
                _vm._v("Mejoras"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comparison-value" }, [
                _vm._v("+12.5%"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "comparison-description" }, [
            _vm._v(
              "\n            Incremento en la tasa de resolución de solicitudes\n          "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "comparison-item" }, [
          _c("div", { staticClass: "comparison-header" }, [
            _c("div", { staticClass: "comparison-icon text-warning" }, [
              _c("i", { staticClass: "fal fa-minus" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "comparison-content" }, [
              _c("div", { staticClass: "comparison-label" }, [
                _vm._v("Estable"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comparison-value" }, [_vm._v("0.0%")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "comparison-description" }, [
            _vm._v(
              "\n            Tiempo promedio de resolución se mantiene estable\n          "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "comparison-item" }, [
          _c("div", { staticClass: "comparison-header" }, [
            _c("div", { staticClass: "comparison-icon text-danger" }, [
              _c("i", { staticClass: "fal fa-arrow-down" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "comparison-content" }, [
              _c("div", { staticClass: "comparison-label" }, [
                _vm._v("Atención"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comparison-value" }, [_vm._v("-5.2%")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "comparison-description" }, [
            _vm._v(
              "\n            Ligera disminución en la satisfacción del usuario\n          "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }